var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangeMedia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2888_4194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.66669 10.0003H18.3334M1.66669 5.83366H5.83335M14.1667 5.83366H18.3334M1.66669 14.167H5.83335M14.1667 14.167H18.3334M5.83335 18.3337V1.66699M14.1667 18.3337V1.66699M5.66669 18.3337H14.3334C15.7335 18.3337 16.4336 18.3337 16.9683 18.0612C17.4387 17.8215 17.8212 17.439 18.0609 16.9686C18.3334 16.4339 18.3334 15.7338 18.3334 14.3337V5.66699C18.3334 4.26686 18.3334 3.5668 18.0609 3.03202C17.8212 2.56161 17.4387 2.17916 16.9683 1.93948C16.4336 1.66699 15.7335 1.66699 14.3334 1.66699H5.66669C4.26656 1.66699 3.56649 1.66699 3.03171 1.93948C2.56131 2.17916 2.17885 2.56161 1.93917 3.03202C1.66669 3.5668 1.66669 4.26686 1.66669 5.66699V14.3337C1.66669 15.7338 1.66669 16.4339 1.93917 16.9686C2.17885 17.439 2.56131 17.8215 3.03171 18.0612C3.56649 18.3337 4.26656 18.3337 5.66669 18.3337Z",
    stroke: "#454C52",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2888_4194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeMedia);
export default __webpack_public_path__ + "static/media/changeMedia.d31a74bbf2709c0a977fbb53c600e556.svg";
export { ForwardRef as ReactComponent };